import {FunctionComponent, useEffect, useState} from "react";
import userService from "../../services/userService";
import {
    Box,
    Card,
    Typography
} from "@mui/material";
import {UserList} from "../common/UserList";
import {IUserModel} from "../../types/UserModel";
import profileVerificationService from "../../services/userVerificationService";

export const IdReviewList: FunctionComponent = () => {
    const [users, setUsers] = useState<IUserModel[]>([]);

    async function getUsers() {
        const requests = await profileVerificationService.getUnreviewedIdRequests();
        const usersFromRequests = await Promise.all(
            requests.map((req) => userService.getUser(req?.id))
        );
        
        setUsers(Array.from(usersFromRequests.values()) as any);
    }

    useEffect(() => {
        void getUsers();
    }, []);

    return (
        <Box>
            <Typography variant={'h1'} sx={{mb: 4}}>
                Review IDs
            </Typography>

            <Card style={{marginBottom: 30}}>
                <UserList users={users} showName={false} showLoginTime={true} to={"id-review"}/>
            </Card>
        </Box>
    )
}